import RoleSimpleView from './RoleSimpleView'

export default RoleSimpleView
